import {
  takeLatest,
  takeEvery
} from 'redux-saga/effects';
import {
  HELP_VIDEO_FETCH_ALL,
  // HELP_VIDEO_ADD,
  HELP_VIDEO_UPDATE,
  HELP_VIDEO_DELETE
} from './constants';
import {
  fetchHelpVids,
  // addHelpVid,
  updateHelpVid,
  deleteHelpVid
} from './sagas';

function *adminHelpVidSagas () {
  yield takeLatest(HELP_VIDEO_FETCH_ALL, fetchHelpVids);
  // yield takeEvery(HELP_VIDEO_ADD, addHelpVid);
  yield takeEvery(HELP_VIDEO_UPDATE, updateHelpVid);
  yield takeEvery(HELP_VIDEO_DELETE, deleteHelpVid);
}

export default adminHelpVidSagas;
